import PropTypes from 'prop-types'
import BasicObject from 'model/basicObject'

class RiskScore extends BasicObject {
  constructor(init) {
    super(init)
    // console.log('> RiskScore constructor -', init)
    this._id = init?.id
    this._risk_score = init?.risk_score
  }

  static shape = {
    id: PropTypes.string.isRequired,
    risk_score: PropTypes.number
  }

  get id() {
    return this._id || ''
  }

  get risk_score() {
    return this._risk_score || 0
  }

  // Calculable
  get normalizeRiskScore() {
    const percentValue = (this.risk_score * 100).toFixed()
    if (+percentValue) {
      return parseInt(percentValue, 10)
    }
    return '--'
  }
}

export default RiskScore
